import { useI18n } from "intl/useI18n";
import "./PriceLabel.scss";
import { cn } from "tailwind-variants";

export default function PriceLabel({ artwork, reorderEnabled, showRetailPrice, ...restProps }) {
  const { n } = useI18n();

  function isLoading() {
    return !Number(artwork.pricing?.enhancementTierRetailPrice);
  }

  function oldPrice() {
    return isLoading() ? 0 : n(artwork.pricing.enhancementTierRetailPrice, "currency");
  }

  function newPrice() {
    return isLoading() ? 0 : n(artwork.pricing.enhancementTierPrice, "currency");
  }

  function shouldShowPrice() {
    return !isLoading() && Number(artwork.pricing?.enhancementTierPrice) > 0;
  }

  return (
    <>
      {shouldShowPrice() ? (
        <span
          {...restProps}
          className={cn(
            "scope-5d14fee4",
            "price-label",
            {
              "price-label--loading": isLoading(),
              "price-label--reorder": reorderEnabled
            },
            restProps.className
          )}
        >
          <span className="price-label__prices scope-5d14fee4">
            <span className="price-label__new-price scope-5d14fee4">{newPrice()}</span>{" "}
            {showRetailPrice ? (
              <span className="price-label__old-price scope-5d14fee4">{oldPrice()}</span>
            ) : null}
          </span>
          <span className="price-label__info scope-5d14fee4">Per Design Size</span>
          {reorderEnabled ? (
            <span className="price-label__reorder scope-5d14fee4">+ Unlimited Reorders!</span>
          ) : null}
        </span>
      ) : null}
    </>
  );
}
